import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import Reveal from "./Reveal";
import { SITE, IMAGES } from "../data/site";
import { trackEvent } from "../utils/analytics";

export const FinalCTA = () => (
  <section className="bg-white" data-testid="final-cta">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 lg:pb-32">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-brand-ink">
          {/* layered depth */}
          <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-brand-blue/30 blur-3xl" aria-hidden="true" />
          <div className="absolute -left-16 -bottom-16 h-64 w-64 rounded-full bg-brand-blue/15 blur-3xl" aria-hidden="true" />
          <img
            src={IMAGES.houseWindows}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover opacity-[0.12]"
            loading="lazy"
          />
          <div className="relative px-7 py-16 md:px-16 md:py-24 max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-ice/70">Hela Skaraborg</p>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-extrabold text-white tracking-tight leading-[1.08]">
              Redo att se klart ut <span className="font-accent italic font-semibold text-brand-ice">igen?</span>
            </h2>
            <p className="mt-5 text-lg text-white/70 leading-relaxed">
              Boka en kostnadsfri offert idag. Vi återkommer snabbt med ett tydligt förslag – utan förpliktelser.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-4">
              <Link
                to="/boka-offert"
                data-testid="final-cta-button"
                onClick={() => trackEvent("boka_click", { location: "final_cta" })}
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand-blue text-white font-semibold px-8 py-4 hover:bg-brand-blueHover hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(14,98,254,0.4)] active:translate-y-0 transition-all duration-300"
              >
                Boka fönsterputs <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
              <a
                href={SITE.phoneHref}
                data-testid="final-cta-phone"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 text-white font-semibold px-8 py-4 hover:bg-white/10 transition-colors"
              >
                <Phone className="h-4 w-4" /> Ring {SITE.phone}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
